import { Checkbox } from '@mui/material';
import { DataGridProps, GridRenderCellParams } from '@mui/x-data-grid';
import { JSX } from 'react';

export interface DataGridEditBooleanCellProps extends GridRenderCellParams {
  /**
   * Persist changes via "processRowUpdate" callback
   */
  processRowUpdate: NonNullable<DataGridProps['processRowUpdate']>;
  /**
   * Optional callback to get current boolean value. Otherwise, "Boolean" function is used by default
   * @param value current field
   * @returns boolean value (true or false)
   */
  getCurrentBooleanValue?: (value: unknown) => boolean;
  /**
   * Optional callback to get field value to set when checkbox state is changed. Otherwise, "Boolean" function is used by default
   * @param value checkbox state
   * @returns field value to set
   */
  getFieldValueFromBoolean?: (value: boolean) => unknown;
  /**
   * Optional flag to disable checkbox
   */
  disabled?: boolean;
}

/**
 * Component for rendering boolean cell with editable checkbox
 */
const DataGridEditBooleanCell = ({
  value,
  field,
  row,
  processRowUpdate,
  disabled,
  getCurrentBooleanValue = Boolean,
  getFieldValueFromBoolean = Boolean,
}: DataGridEditBooleanCellProps): JSX.Element => {
  return (
    <Checkbox
      sx={{ padding: '2px' }}
      disabled={disabled}
      checked={getCurrentBooleanValue(value)}
      onChange={({ target }): void =>
        processRowUpdate({ ...row, [field]: getFieldValueFromBoolean(target.checked) }, row, {
          rowId: row.id,
        })
      }
    />
  );
};

export default DataGridEditBooleanCell;
